import {
  Card,
  CardBody,
  FormGroup,
  Form,
  Input,
  Row,
  Col,
  Breadcrumb,
  BreadcrumbItem,
  CardHeader,
  CardTitle,
  Button,
} from "reactstrap";
import { NavLink } from "react-router-dom";
import { useState, React, useEffect, useContext } from "react";
import { useHistory, useLocation } from "react-router-dom";
import { ToastContainer, toast } from "react-toastify";
import Switch from "react-bootstrap-switch";
import "react-toastify/dist/ReactToastify.css";
import LoadingOverlay from "react-loading-overlay";
import SelectComponent from "components/Utils/select.js";
import { poe, poeBulk } from "data/subscribers.js";
import { MainContext } from "context/MainContext.js";
import { faHome } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import Utilities from "components/Utils/utilities";
import Checkbox from "react-three-state-checkbox";
LoadingOverlay.propTypes = undefined;

const SubscriberEdit = () => {
  const history = useHistory();
  const location = useLocation();

  const [formError, setFormError] = useState(false);

  const [devices, setDevices] = useState([]);
  const [bandwidths, setBandwidths] = useState([]);
  const [unsetEndpoints, setUnsetEndpoints] = useState([]);
  const [ports, setPorts] = useState([]);
  const [uplinkPorts, setUplinkPorts] = useState([]);
  const [profiles, setProfiles] = useState([]);

  const [deviceFirmware, setDeviceFirmware] = useState(null);
  const [subscriberModel, setSubscriberModel] = useState("");
  const [fullProfiles, setFullProfiles] = useState([]);

  const [selectedGam, setSelectedGam] = useState(null);
  const [selectedUplinkPort, setSelectedUplinkPort] = useState(null);
  const [selectedDetectedEndpoint, setSelectedDetectedEndpoint] =
    useState(null);
  const [selectedPort, setSelectedPort] = useState(null);
  const [selectedBandwidth, setSelectedBandwidth] = useState(null);
  const [selectedPoe, setSelectedPoe] = useState("enable");
  const [selectedProfile, setSelectedProfile] = useState(null);

  const [show2PortsSection, setShow2PortsSection] = useState(false);
  const [showPoe, setShowPoe] = useState(false);

  const [errorMsg, setErrorMsg] = useState([]);
  const [showLoading, setShowLoading] = useState(false);
  const privileges = useContext(MainContext);

  const [initialBulkValues, setInitialBulkValues] = useState({});
  const [initialBulkBooleans, setInitialBulkBooleans] = useState({});

  const [mixedFields, setMixedFields] = useState({});

  const [isDependenciesLoading, setIsDependenciesLoading] = useState(false);

  useEffect(() => {
    if (
      !Utilities.hasAccess(privileges["devices.subscribers.edit"]) &&
      !Utilities.hasAccess(privileges["devices.subscribers.create"])
    ) {
      history.push({ pathname: "/" });
    } else if (Utilities.hasAgreedTerms() == "false") {
      history.push({ pathname: "/auth/terms" });
    }
  }, []);

  const [bulklist, setBulklist] = useState(
    location.state ? location.state.bulklist : "",
  );

  const [bulkChange, setBulkChange] = useState(
    location.state && location.state.bulklist
      ? location.state.bulklist.length > 1
      : false,
  );

  const [poeList, setPoeList] = useState(bulkChange ? poeBulk : poe);

  const [subscriberId, setSubscriberId] = useState(() => {
    if (location.state) {
      if (location.state.value) {
        return location.state.value;
      }
      if (location.state.bulklist?.length === 1) {
        return location.state.bulklist[0];
      }
    }
    return "";
  });

  useEffect(() => {
    if (subscriberId) {
      fetchEditData(subscriberId);
    } else if (bulkChange) {
      fetchBulkData(bulklist);
    } else {
      fetchCreateData();
    }
  }, []);

  const [values, setValues] = useState({
    gam_serial_number: "",
    mac_address: "",
    name: "",
    description: "",
    subscriber_name: "",
    subscriber_description: "",
    vlan: "",
    remapped_vid: "",
    endpoint_tagging: null,
    double_tagging: null,
    trunk_mode: null,
    allowed_tagged_vlan: "",
    bandwidth: "",
    vlan2: "",
    endpoint_tagging_2: null,
    poe: "",
    allowed_tagged_vlan_2: "",
    s_vlan_outer_tag: "",
    s_vlan_uplink_port: "",
    port: "",
    profile: "",
  });

  const [states, setStates] = useState({
    gam_serial_number: "",
    mac_address: "",
    name: "",
    description: "",
    subscriber_name: "",
    subscriber_description: "",
    vlan: "",
    remapped_vid: "",
    endpoint_tagging: "",
    double_tagging: "",
    trunk_mode: "",
    allowed_tagged_vlan: "",
    bandwidth: "",
    vlan2: "",
    endpoint_tagging_2: "",
    poe: "",
    allowed_tagged_vlan_2: "",
    s_vlan_outer_tag: "",
    s_vlan_uplink_port: "",
    port: "",
    profile: "",
  });

  const fetchCreateData = () => {
    // Fetch initial data required to populate the "create subscriber" form
    fetch("/api/v1/subscriber/create", {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        sessionId: sessionStorage.getItem("sessionId"),
      },
    })
      .then((response) => response.json())
      .then((actualData) => {
        // Populate devices dropdown with data from the API
        setDevices(actualData.data.devices);

        // Prepend a default "Unthrottled" option to the bandwidth list, then update state
        const bandwidthList = [
          { value: "0", label: "Unthrottled" },
          ...actualData.data.bandwidths,
        ];
        setBandwidths(bandwidthList);
        applyDefaultBandwidth(bandwidthList);

        // Build the profiles dropdown options
        // Always include "Ad Hoc" as the first option regardless of fetched data
        const adhocProfileOption = { value: "-1", label: "Ad Hoc" };
        const rawProfiles = actualData.data.profiles ?? [];

        // Normalize raw profile data into { value, label } shape
        const formattedProfiles = rawProfiles.map((profile) => ({
          value: profile.value,
          label: profile.label,
        }));

        // If profiles were returned, prepend "Ad Hoc"; otherwise use "Ad Hoc" alone
        const profileOptions =
          rawProfiles.length > 0
            ? [adhocProfileOption, ...formattedProfiles]
            : [adhocProfileOption];

        setProfiles(profileOptions);

        // Set the selected profile to the one returned by the API, falling back to "Ad Hoc"
        const defaultProfile =
          profileOptions.find(
            (profile) => profile.value === actualData.data.profileId,
          ) ?? adhocProfileOption;
        setSelectedProfile(defaultProfile);
        setValues((prev) => ({ ...prev, profile: defaultProfile.value }));
      })
      // Log any network or parsing errors to the console
      .catch((err) => {
        console.log(err.message);
      });
  };

  const fetchEditData = (subscriberId) => {
    setShowLoading(true);
    fetch("/api/v1/subscriber/edit", {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        sessionId: sessionStorage.getItem("sessionId"),
        subscriberId: subscriberId,
      },
    })
      .then((response) => response.json())
      .then((actualData) => {
        setShowLoading(false);
        const endpoint = actualData.data.endpoint;
        const subscriber = actualData.data.subscriber;

        setDevices(actualData.data.devices);

        actualData.data.devices.forEach((item) => {
          if (
            actualData.data.deviceSerialNumber &&
            item.value == actualData.data.deviceSerialNumber
          ) {
            setSelectedGam(item);
            setValues((prevState) => ({
              ...prevState,
              ["gam_serial_number"]: item.value,
            }));
            setDeviceFirmware(item.data.firmwareVersion);
          }
        });

        const subscriberModelVar = actualData.data.subscriberModel;
        setSubscriberModel(subscriberModelVar);
        if (subscriberModelVar == "portAware") {
          setUnsetEndpoints([]);
        } else if (subscriberModelVar == "endpointAware") {
          fetchUnsetEndpoints(actualData.data.deviceSerialNumber, endpoint);
        }

        const ports = actualData.data.ports;
        const portAutoOption = { value: "", label: "Auto" };
        var selectedPortTemp = null;
        setPorts([portAutoOption, ...ports]);
        var subscriberPort = null;

        var confPortIfIndex = null;
        if (endpoint) {
          confPortIfIndex = endpoint.confPortIfIndex;
        } else if (subscriber) {
          confPortIfIndex = subscriber.portIfIndex;
        }

        ports.map((port) => {
          if (port.label == confPortIfIndex) {
            subscriberPort = port;
          }
        });

        if (subscriberPort) {
          setSelectedPort(subscriberPort);
          selectedPortTemp = subscriberPort;
        } else {
          setSelectedPort(portAutoOption);
          selectedPortTemp = portAutoOption;
        }

        fetchUplinkPorts(
          actualData.data.deviceSerialNumber,
          actualData.data.subscriber.nniIfIndex,
        );

        var endpointDetails = false;
        if (
          endpoint &&
          (endpoint.confEndpointName != subscriber.name ||
            endpoint.confEndpointDescription != subscriber.description)
        ) {
          endpointDetails = true;
        }

        setValues((prevState) => ({
          ...prevState,
          ["gam_serial_number"]: actualData.data.deviceSerialNumber,
          ["name"]: endpoint ? endpoint.confEndpointName : "",
          ["description"]: endpoint ? endpoint.confEndpointDescription : "",
          ["double_tagging"]: subscriber.doubleTags,
          ["subscriber_name"]: subscriber.name,
          ["subscriber_description"]: subscriber.description,
          ["trunk_mode"]: subscriber.trunkMode,
          ["mac_address"]: endpoint ? endpoint.macAddress : "",
          ["endpoint_tagging"]: subscriber.vlanIsTagged,
          ["endpoint_tagging_2"]: subscriber.vlanIsTagged2,
          ["vlan"]: actualData.data.vlan || "",
          ["vlan2"]: subscriber.port2VlanId || "",
          ["remapped_vid"]: subscriber.remappedVlanId || "",
          ["s_vlan_outer_tag"]: actualData.data.outerTag || "",
          ["bandwidth"]: actualData.data.bandwidthId,
          ["poe"]: subscriber.poeModeCtrl,
          ["endpoint_details"]: endpointDetails,
          ["allowed_tagged_vlan"]: subscriber.allowedTaggedVlan,
          ["allowed_tagged_vlan_2"]: subscriber.allowedTaggedVlan2,
          ["port"]: selectedPortTemp ? selectedPortTemp.value : "",
          ["s_vlan_uplink_port"]: actualData.data.uplinkPortId,
        }));

        setDefaultPoe(subscriber.poeModeCtrl);

        const adhocOption = { value: "-1", label: "Ad Hoc" };
        const fetchedOptionsRawData = actualData.data.profiles ?? [];

        const formattedOptions = fetchedOptionsRawData.map((item) => ({
          value: item.value,
          label: item.label,
        }));

        const options =
          fetchedOptionsRawData.length > 0
            ? [adhocOption, ...formattedOptions]
            : [adhocOption];

        setProfiles(options);

        const defaultProfile =
          options.find((o) => o.value === actualData.data.profileId) ??
          adhocOption;
        setSelectedProfile(defaultProfile);
        setValues((prev) => ({ ...prev, profile: defaultProfile.value }));

        var bandwidthList = [
          { value: "0", label: "Unthrottled" },
          ...actualData.data.bandwidths,
        ];

        setBandwidths(bandwidthList);
        applyDefaultBandwidth(bandwidthList, actualData.data.bandwidthId);

        setShow2PortsSection(actualData.data.has2PortsModel ?? false);
        setShowPoe(
          actualData.data.modelType?.toUpperCase().includes("PLUS") === true,
        );
      })
      .catch((err) => {
        console.log(err);
        setShowLoading(false);
      });
  };

  const fetchBulkData = (bulklist) => {
    setShowLoading(true);
    fetch("/api/v1/subscriber/bulk/edit", {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        sessionId: sessionStorage.getItem("sessionId"),
        bulklist: bulklist,
      },
    })
      .then((response) => response.json())
      .then((actualData) => {
        setShowLoading(false);
        const data = actualData.data;

        // ── Flags Mixed ─────────────────────────────────────────────
        setMixedFields({
          vlan: data.vlanMixed ?? false,
          vlan2: data.vlan2Mixed ?? false,
          remapped_vid: data.remappedVlanIdMixed ?? false,
          allowed_tagged_vlan: data.allowedTaggedVlanMixed ?? false,
          allowed_tagged_vlan_2: data.allowedTaggedVlan2Mixed ?? false,
          s_vlan_outer_tag: data.outerTagMixed ?? false,
          s_vlan_uplink_port: data.uplinkPortMixed ?? false,
          poe: data.poeModeCtrlMixed ?? false,
          profile: data.profileMixed ?? false,
        });

        setInitialBulkBooleans({
          trunk_mode: data.trunkModeMixed ? null : data.trunkMode ?? false,
          double_tagging: data.doubleTaggingMixed
            ? null
            : data.doubleTagging ?? false,
          endpoint_tagging: data.endpointTaggingMixed
            ? null
            : data.endpointTagging ?? false,
          endpoint_tagging_2: data.endpointTagging2Mixed
            ? null
            : data.endpointTagging2 ?? false,
        });

        // ── Bandwidth ────────────────────────────────────────────────
        var bandwidthList = [
          { value: "0", label: "Unthrottled" },
          ...data.bandwidths,
        ];

        if (data.bandwidth === "MIXED") {
          bandwidthList = [
            { value: "MIXED", label: "-- mixed --" },
            ...bandwidthList,
          ];
        }

        setBandwidths(bandwidthList);
        applyDefaultBandwidth(bandwidthList, data.bandwidth);

        // ── Uplink Ports ─────────────────────────────────────────────
        if (data.uplinkPorts.length > 0) {
          var formattedOptions = data.uplinkPorts.map((item) => ({
            value: item,
            label: item,
          }));
          setUplinkPorts(formattedOptions);
          applyBulkDefaultUplinkPort(formattedOptions, data.uplinkPort);
        } else {
          setUplinkPorts([]);
        }

        // ── Profiles ─────────────────────────────────────────────────
        const adhocOption = { value: "-1", label: "Ad Hoc" };
        const fetchedOptionsRawData = data.profiles ?? [];

        const formattedProfileOptions = fetchedOptionsRawData.map((item) => ({
          value: item.value,
          label: item.label,
        }));

        const options =
          fetchedOptionsRawData.length > 0
            ? [adhocOption, ...formattedProfileOptions]
            : [adhocOption];

        setProfiles(options);

        const defaultProfile =
          options.find((o) => o.value === data.profile) ?? adhocOption;
        setSelectedProfile(defaultProfile);

        setDefaultPoe(data.poeModeCtrlMixed ? null : data.poeModeCtrl);

        const bulkValues = {
          profile: defaultProfile.value,
          double_tagging: data.doubleTaggingMixed
            ? null
            : data.doubleTagging ?? false,
          endpoint_tagging: data.endpointTaggingMixed
            ? null
            : data.endpointTagging ?? false,
          endpoint_tagging_2: data.endpointTagging2Mixed
            ? null
            : data.endpointTagging2 ?? false,
          trunk_mode: data.trunkModeMixed ? null : data.trunkMode ?? false,
          vlan: data.vlanMixed ? "" : data.vlan ?? "",
          vlan2: data.vlan2Mixed ? "" : data.vlan2 ?? "",
          remapped_vid: data.remappedVlanIdMixed
            ? ""
            : data.remappedVlanId ?? "",
          allowed_tagged_vlan: data.allowedTaggedVlanMixed
            ? ""
            : data.allowedTaggedVlan ?? "",
          allowed_tagged_vlan_2: data.allowedTaggedVlan2Mixed
            ? ""
            : data.allowedTaggedVlan2 ?? "",
          s_vlan_outer_tag: data.outerTagMixed ? "" : data.outerTag ?? "",
          s_vlan_uplink_port: data.uplinkPortMixed ? "" : data.uplinkPort ?? "",
          bandwidth: data.bandwidth ?? "",
          poe: data.poeModeCtrlMixed ? "" : data.poeModeCtrl ?? "",
        };

        setInitialBulkValues(bulkValues);
        setValues((prev) => ({ ...prev, ...bulkValues }));

        setShow2PortsSection(data.has2PortsModel);
        setShowPoe(data.hasPoeModel ?? false);
      })
      .catch((err) => {
        console.log(err);
        setShowLoading(false);
      });
  };

  const getChangedBulkValues = () => {
    const changed = {};
    Object.keys(initialBulkValues).forEach((key) => {
      if (values[key] !== initialBulkValues[key]) {
        changed[key] = values[key];
      }
    });
    return changed;
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    let hasError = false;
    const newStates = { ...states };

    const validate = (field, validator) => {
      const error = validator(field, values);
      newStates[field] = error ?? "";
      if (error) hasError = true;
    };

    if (!bulkChange) {
      if (isEndpointAware()) {
        validate("name", (f, v) => Utilities.validateField(f, v, setFormError));
      }

      validate("subscriber_name", (f, v) =>
        Utilities.validateField(f, v, setFormError),
      );

      if (isCreationMode()) {
        validate("gam_serial_number", (f, v) =>
          Utilities.validateField(f, v, setFormError),
        );
      }

      if (isEndpointAware()) {
        validate("mac_address", (f, v) =>
          Utilities.validateMacAddress(f, v, setFormError),
        );
      }

      if (!hasProfileSelected()) {
        validate("vlan", (f, v) => {
          const error = Utilities.validateVlan(f, v, setFormError);
          if (error) return error;

          if (!bulkChange) {
            const vlanVal = parseInt(v.vlan, 10);
            if (isNaN(vlanVal) || vlanVal < 3 || vlanVal > 4094) {
              return "VLAN must be between 3 and 4094";
            }
          }

          return null;
        });
        if (values["double_tagging"]) {
          validate("s_vlan_outer_tag", (f, v) =>
            Utilities.validateVlan(f, v, setFormError),
          );
        }
        validate("poe", (f, v) => Utilities.validateField(f, v, setFormError));
        validate("bandwidth", (f, v) =>
          Utilities.validateField(f, v, setFormError),
        );
      }
    }
    setStates(newStates);

    if (!hasError) {
      postData();
    }
  };

  const postData = () => {
    setShowLoading(true);

    let apiUrl = "";
    let apiMethod = "";

    if (bulkChange) {
      const changedValues = getChangedBulkValues();

      if (Object.keys(changedValues).length === 0) {
        setShowLoading(false);
        toast.warning("No fields modified", {
          position: "top-center",
          autoClose: 3000,
          hideProgressBar: true,
          closeOnClick: false,
          pauseOnHover: false,
          draggable: false,
          theme: "colored",
        });
        return;
      }

      fetch("/api/v1/subscriber/bulk/edit", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          sessionId: sessionStorage.getItem("sessionId"),
          bulklist: bulklist,
        },
        body: JSON.stringify({
          vlan:
            changedValues.vlan === undefined ? undefined : changedValues.vlan,
          vlan2:
            changedValues.vlan2 === undefined ? undefined : changedValues.vlan2,
          endpointTagging: changedValues.endpoint_tagging,
          endpointTagging2: changedValues.endpoint_tagging_2,
          doubleTagging: changedValues.double_tagging,
          remappedVlanId: changedValues.remapped_vid,
          allowedTaggedVlan: changedValues.allowed_tagged_vlan,
          allowedTaggedVlan2: changedValues.allowed_tagged_vlan_2,
          outerTag: changedValues.s_vlan_outer_tag,
          uplinkPort: changedValues.s_vlan_uplink_port,
          bandwidth:
            changedValues.bandwidth === "MIXED"
              ? undefined
              : changedValues.bandwidth,
          poeModeCtrl: changedValues.poe,
          profile: changedValues.profile,
        }),
      })
        .then((response) => response.json())
        .then((actualData) => {
          setShowLoading(false);
          if (actualData.error_code) {
            setErrorMsg(actualData.error_code);
            toast.error("A problem occured while editing the subscribers", {
              position: "top-center",
              autoClose: 3000,
              hideProgressBar: true,
              closeOnClick: false,
              pauseOnHover: false,
              draggable: false,
              theme: "colored",
            });
          } else {
            setErrorMsg("");
            redirectToBulkConfirmationPage(actualData.data);
          }
        })
        .catch((err) => {
          console.log(err);
        });
    } else if (!subscriberId) {
      apiUrl = "/api/v1/subscriber/create";
      apiMethod = "POST";

      fetch(apiUrl, {
        method: apiMethod,
        headers: {
          "Content-Type": "application/json",
          sessionId: sessionStorage.getItem("sessionId"),
        },
        body: JSON.stringify({
          gamSerialNumber: values.gam_serial_number,
          macAddress: values.mac_address,
          name: values.name,
          description: values.description,
          subscriber_name: values.subscriber_name,
          subscriber_description: values.subscriber_description,
          vlan: values.vlan,
          remapped_vid: values.remapped_vid,
          endpoint_tagging: values.endpoint_tagging,
          double_tagging: values.double_tagging,
          trunk_mode: values.trunk_mode,
          allowed_tagged_vlan: values.allowed_tagged_vlan,
          bandwidth_id: values.bandwidth,
          vlan2: values.vlan2,
          endpoint_tagging_2: values.endpoint_tagging_2,
          poe: values.poe,
          allowed_tagged_vlan_2: values.allowed_tagged_vlan_2,
          outerTag: values.s_vlan_outer_tag,
          selectedDetectedEndpoint: selectedDetectedEndpoint
            ? selectedDetectedEndpoint.value
            : "",
          port_id: values.port,
          uplink_port: values.s_vlan_uplink_port,
          profile: values.profile,
        }),
      })
        .then((response) => response.json())
        .then((actualData) => {
          setShowLoading(false);
          if (actualData.error_code) {
            setErrorMsg(actualData.error_code);
            toast.error("A problem occured while creating the subscriber", {
              position: "top-center",
              autoClose: 3000,
              hideProgressBar: true,
              closeOnClick: false,
              pauseOnHover: false,
              draggable: false,
              theme: "colored",
            });
          } else {
            setErrorMsg([]);
            toast.success("Subscriber created successfully", {
              position: "top-center",
              autoClose: 3000,
              hideProgressBar: true,
              closeOnClick: false,
              pauseOnHover: false,
              draggable: false,
              theme: "colored",
            });
            resetForm();
          }
        })
        .catch((err) => {
          console.log(err.message);
          setShowLoading(false);
        });
    } else {
      apiUrl = "/api/v1/subscriber/edit";
      apiMethod = "PUT";

      fetch(apiUrl, {
        method: apiMethod,
        headers: {
          "Content-Type": "application/json",
          sessionId: sessionStorage.getItem("sessionId"),
        },
        body: JSON.stringify({
          subscriberId: subscriberId,
          macAddress: values.mac_address,
          name: values.name,
          description: values.description,
          subscriber_name: values.subscriber_name,
          subscriber_description: values.subscriber_description,
          vlan: values.vlan,
          remapped_vid: values.remapped_vid,
          endpoint_tagging: values.endpoint_tagging,
          double_tagging: values.double_tagging,
          trunk_mode: values.trunk_mode,
          allowed_tagged_vlan: values.allowed_tagged_vlan,
          bandwidth_id: values.bandwidth,
          vlan2: values.vlan2,
          endpoint_tagging_2: values.endpoint_tagging_2,
          poe: values.poe,
          allowed_tagged_vlan_2: values.allowed_tagged_vlan_2,
          outerTag: values.s_vlan_outer_tag,
          selectedDetectedEndpoint: selectedDetectedEndpoint
            ? selectedDetectedEndpoint.value
            : "",
          port_id: values.port,
          uplink_port: values.s_vlan_uplink_port,
          profile: values.profile,
        }),
      })
        .then((response) => response.json())
        .then((actualData) => {
          setShowLoading(false);
          if (actualData.error_code) {
            setErrorMsg(actualData.error_code);
            toast.error("A problem occured while editing the subscriber", {
              position: "top-center",
              autoClose: 3000,
              hideProgressBar: true,
              closeOnClick: false,
              pauseOnHover: false,
              draggable: false,
              theme: "colored",
            });
          } else {
            setErrorMsg([]);
            toast.success("Subscriber edited successfully", {
              position: "top-center",
              autoClose: 3000,
              hideProgressBar: true,
              closeOnClick: false,
              pauseOnHover: false,
              draggable: false,
              theme: "colored",
            });
            resetForm();
            fetchEditData(subscriberId);
          }
        })
        .catch((err) => {
          console.log(err.message);
          setShowLoading(false);
        });
    }
  };

  const fetchUnsetEndpoints = (gam_serial_number, endpoint) => {
    return fetch("/api/v1/endpoint/unset", {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        sessionId: sessionStorage.getItem("sessionId"),
        gamSerialNumber: gam_serial_number,
        subscriberId: subscriberId,
      },
    })
      .then((response) => response.json())
      .then((actualData) => {
        const createOption = { value: "-1", label: "Create a new Endpoint" };

        if (actualData.data.length > 0) {
          const fetchedOptionsRawData = actualData.data;

          const formattedOptions = fetchedOptionsRawData.map((item) => ({
            value: item.value,
            label: item.label,
            has2Ports: item.has2Ports ?? false,
            modelType: item.modelType,
          }));

          setUnsetEndpoints([createOption, ...formattedOptions]);

          if (endpoint) {
            const defaultEndpoint = formattedOptions.find(
              (item) => item.value === endpoint.macAddress,
            );
            setSelectedDetectedEndpoint(defaultEndpoint);
          }
        } else {
          setUnsetEndpoints([createOption]);
        }
      })
      .catch((err) => {
        console.log(err.message);
      });
  };

  const fetchUplinkPorts = (gam_serial_number, defaultValue) => {
    return fetch("/api/v1/port/list/uplink/port", {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        sessionId: sessionStorage.getItem("sessionId"),
        serialNumber: gam_serial_number,
      },
    })
      .then((response) => response.json())
      .then((actualData) => {
        if (actualData.data.length > 0) {
          var fetchedOptionsData = actualData.data;

          setUplinkPorts(fetchedOptionsData);

          setSelectedUplinkPort(
            fetchedOptionsData.find((port) => port.label === defaultValue),
          );
        } else {
          setUplinkPorts([]);
        }
      })
      .catch((err) => {
        console.log(err.message);
      });
  };

  const resetForm = () => {
    setValues({
      ...values,
      ["gam_serial_number"]: "",
      ["mac_address"]: "",
      ["name"]: "",
      ["description"]: "",
      ["subscriber_name"]: "",
      ["subscriber_description"]: "",
      ["vlan"]: "",
      ["remapped_vid"]: "",
      ["endpoint_tagging"]: null,
      ["double_tagging"]: null,
      ["trunk_mode"]: false,
      ["allowed_tagged_vlan"]: "",
      ["bandwidth"]: "",
      ["vlan2"]: "",
      ["endpoint_tagging_2"]: null,
      ["poe"]: "",
      ["allowed_tagged_vlan_2"]: "",
      ["s_vlan_outer_tag"]: "",
      ["endpoint_details"]: false,
      ["profile"]: "",
    });

    setMixedFields({});
    setSelectedGam(null);
    setSelectedDetectedEndpoint(null);
    setSelectedPort(null);
    setSelectedUplinkPort(null);
    setSelectedProfile(null);
    setUnsetEndpoints([]);
    setPorts([]);
    setDefaultPoe("enable");
    setDeviceFirmware(null);
    applyDefaultBandwidth(bandwidths);

    fetchCreateData();
  };

  const applyDefaultBandwidth = (list, defaultValue) => {
    if (defaultValue === "MIXED") {
      const mixedOption = list.find((item) => item.value === "MIXED");
      if (mixedOption) {
        setSelectedBandwidth(mixedOption);
        setValues((prevState) => ({ ...prevState, ["bandwidth"]: "MIXED" }));
      }
      return;
    }

    var found = false;
    list.forEach((item) => {
      const match = defaultValue
        ? item.value == defaultValue
        : item.label == "Unthrottled";

      if (match) {
        setSelectedBandwidth(item);
        setValues((prevState) => ({ ...prevState, ["bandwidth"]: item.value }));
        found = true;
      }
    });

    if (!found) {
      setSelectedBandwidth(null);
      setValues((prevState) => ({ ...prevState, ["bandwidth"]: "" }));
    }
  };

  const applyBulkDefaultUplinkPort = (list, defaultValue) => {
    var found = false;

    list.forEach((item) => {
      if (item.value == defaultValue) {
        setSelectedUplinkPort(item);
        setValues((prevState) => ({
          ...prevState,
          ["s_vlan_uplink_port"]: item.value,
        }));
        found = true;
      }
    });
    if (!found) {
      setSelectedUplinkPort(null);
      setValues((prevState) => ({
        ...prevState,
        ["s_vlan_uplink_port"]: "",
      }));
    }
  };

  const setDefaultPoe = (defaultValue) => {
    if (defaultValue === null) {
      const noneOption = poeList.find(
        (item) => item.value === null || item.value === "",
      );
      if (noneOption) {
        setSelectedPoe(noneOption);
      }
      return;
    }

    poeList.forEach((item) => {
      if (item.value === defaultValue) {
        setSelectedPoe(item);
      }
    });
  };

  const handleBandwidthChange = (option) => {
    if (bulkChange) {
      setValues({
        ...values,
        ["bandwidth"]:
          option.value.value === "MIXED" ? "MIXED" : option.value.label,
      });
    } else {
      setValues({
        ...values,
        ["bandwidth"]: option.value.value,
      });
    }
    setSelectedBandwidth(option);
  };

  const handlePoeChange = (option) => {
    setValues({
      ...values,
      ["poe"]: option.value.value,
    });
    setSelectedPoe(option);
  };

  const handleUplinkPortChange = (option) => {
    setValues({
      ...values,
      ["s_vlan_uplink_port"]: option.value.value,
    });
    setSelectedUplinkPort(option);
  };

  const handleGamChange = (option) => {
    setIsDependenciesLoading(true);
    resetForm();

    setValues({
      ...values,
      ["gam_serial_number"]: option.value.value,
      ["poe"]: "disable",
    });
    setSelectedGam(option);
    setDeviceFirmware(option.value.data.firmwareVersion);

    const subscriberModelVar = option.value.data.subscriberModel;
    setSubscriberModel(subscriberModelVar);

    const fetchPromises = [];

    if (subscriberModelVar == "portAware") {
      setUnsetEndpoints([]);
    } else {
      fetchPromises.push(fetchUnsetEndpoints(option.value));
    }

    fetchPromises.push(fetchUplinkPorts(option.value));

    Promise.all(fetchPromises).finally(() => {
      setIsDependenciesLoading(false);
    });

    const unsortedPorts = option.value.data.ports;
    const sortedPorts = unsortedPorts.sort((a, b) => {
      const numA = parseInt(a.label.split("/")[1], 10);
      const numB = parseInt(b.label.split("/")[1], 10);
      return numA - numB;
    });
    const portAutoOption = { value: "", label: "Auto" };
    setPorts([portAutoOption, ...sortedPorts]);
  };

  const handleEndpointChange = (option) => {
    if (option.value != "-1") {
      const hasPlusModel =
        option.modelType?.toUpperCase().includes("PLUS") === true;

      setValues((prevState) => ({
        ...prevState,
        ["mac_address"]: option.value,
        ["name"]: getEndpointNameFromMacAddress(option.value),
        ["subscriber_name"]: getEndpointNameFromMacAddress(option.value),
        ["poe"]: hasPlusModel ? "enable" : "disable",
      }));

      setShow2PortsSection(option.has2Ports ?? false);
      const hasPlusModelBool = hasPlusModel;
      setShowPoe(hasPlusModelBool);

      setDefaultPoe(hasPlusModel ? "enable" : "disable");
    } else {
      setShow2PortsSection(false);
      setShowPoe(false);

      setValues((prevState) => ({
        ...prevState,
        ["poe"]: "enable",
      }));
      setDefaultPoe("enable");
    }

    setSelectedDetectedEndpoint(option);

    if (option) {
      if (!option.label.includes("Unknown MAC") && option.value != "-1") {
        setValues((prevState) => ({
          ...prevState,
          ["endpoint_details"]: true,
        }));
      } else {
        setValues((prevState) => ({
          ...prevState,
          ["endpoint_details"]: false,
        }));
      }
    }
  };

  const handlePortChange = (option) => {
    if (subscriberModel == "portAware") {
      setValues((prevState) => ({
        ...prevState,
        ["mac_address"]: "",
        ["name"]: "",
        ["description"]: "",
        ["port"]: option.value.value,
      }));
    } else {
      setValues((prevState) => ({
        ...prevState,
        ["port"]: option.value.value,
      }));
    }

    setSelectedPort(option);
  };

  const handleProfileChange = (option) => {
    setValues((prevState) => ({
      ...prevState,
      ["profile"]: option.value.value,
    }));

    setSelectedProfile(option);
  };

  const handleTrunkChange = (e) => {
    const { props, state } = e;

    setValues({
      ...values,
      [props.name]: state.value,
      ["allowed_tagged_vlan"]: "",
      ["allowed_tagged_vlan_2"]: "",
    });
  };

  const getEndpointNameFromMacAddress = (macAddress) => {
    if (macAddress) {
      var macSplit = macAddress.split(":");

      return (
        "Positron_" + (macSplit[3] + macSplit[4] + macSplit[5]).toUpperCase()
      );
    } else {
      return "";
    }
  };

  const showSubscriberDetails = () => {
    if (isDependenciesLoading) return false;

    if (bulkChange) {
      return true;
    }

    if (!selectedGam) return false;
    if (!selectedProfile && isCreationMode()) return false;

    if (subscriberModel == "portAware") {
      return !!selectedPort;
    }

    if (subscriberModel == "endpointAware") {
      if (unsetEndpoints.length > 0) {
        return !!selectedDetectedEndpoint;
      }
      return true;
    }

    return false;
  };

  const showServiceDetails = () => {
    if (isDependenciesLoading) return false;

    if (bulkChange) {
      return selectedProfile?.value == -1;
    }
    if (!selectedGam) return false;
    if (!selectedProfile || selectedProfile.value != -1) return false;

    if (subscriberModel == "portAware") {
      return !!selectedPort;
    }
    if (subscriberModel == "endpointAware") {
      if (unsetEndpoints.length > 0) {
        return !!selectedDetectedEndpoint;
      }
      return true;
    }

    return false;
  };

  const showSubmitButton = () => {
    if (
      showSubscriberDetails() ||
      (selectedProfile && selectedProfile.value.value != -1) ||
      bulkChange
    ) {
      return true;
    } else {
      return false;
    }
  };

  const isCreationMode = () => {
    return !subscriberId ? true : false;
  };

  const isEndpointAware = () => {
    return unsetEndpoints && unsetEndpoints.length > 0;
  };

  const hasProfileSelected = () => {
    return (
      selectedProfile?.value?.value !== undefined &&
      selectedProfile.value.value != -1
    );
  };

  const redirectToBulkConfirmationPage = (changes) => {
    const location = {
      pathname: "/admin/subscribers/edit/confirm",
      state: {
        bulklist: bulklist,
        changes: changes,
      },
    };
    history.push(location);
  };

  const handleThreeStateChange = (field) => {
    setValues((prevStates) => {
      const currentState = prevStates[field];
      const wasConflict = initialBulkBooleans[field] === null;

      if (wasConflict) {
        const nextState =
          currentState === null ? true : currentState === true ? false : null;
        return { ...prevStates, [field]: nextState };
      } else {
        return { ...prevStates, [field]: !currentState };
      }
    });
  };

  return (
    <>
      <ToastContainer />
      <div className="content">
        <LoadingOverlay
          active={showLoading}
          spinner
          text="Loading"
          className={showLoading ? "loading" : ""}
        />

        <Row>
          <Col md="12">
            <Card>
              <CardBody>
                <Breadcrumb>
                  <BreadcrumbItem>
                    <NavLink to={{ pathname: "/admin/dashboard" }}>
                      <FontAwesomeIcon icon={faHome} />
                    </NavLink>
                  </BreadcrumbItem>

                  <BreadcrumbItem>
                    <NavLink to={{ pathname: "/admin/subscribers/list" }}>
                      Subscribers
                      {bulklist && bulklist.length > 1
                        ? " <" + bulklist.length + " selected>"
                        : ""}
                    </NavLink>
                  </BreadcrumbItem>

                  <BreadcrumbItem>
                    {bulkChange
                      ? "Edit"
                      : subscriberId
                      ? `Edit <${subscriberId}>`
                      : "Create"}
                  </BreadcrumbItem>
                </Breadcrumb>
              </CardBody>
            </Card>
          </Col>
        </Row>

        <Row>
          <Col>
            {errorMsg.length > 0 ? (
              <div
                style={{
                  backgroundColor: "#FFC0A4",
                  border: "1px solid #ef8157",
                  color: "#66615b",
                  paddingTop: "15px",
                  marginBottom: "15px",
                }}
              >
                <ul>
                  {errorMsg.map((d, index) => (
                    <li key={index}>{d}</li>
                  ))}
                </ul>
              </div>
            ) : (
              ""
            )}
          </Col>
        </Row>
        <Row>
          <Col>
            <Form onSubmit={handleSubmit}>
              <Card>
                <CardHeader>
                  <CardTitle tag="h4">Device Information</CardTitle>
                </CardHeader>

                <CardBody>
                  <Row>
                    {!bulkChange ? (
                      <Col>
                        {devices ? (
                          <SelectComponent
                            label="Device"
                            fieldName={"gam_serial_number"}
                            array={devices}
                            stateValue={states["gam_serial_number"]}
                            onChange={(option) => {
                              handleGamChange(option);
                            }}
                            selectedOption={selectedGam}
                            disabled={subscriberId}
                          />
                        ) : (
                          ""
                        )}
                      </Col>
                    ) : (
                      <Col></Col>
                    )}

                    {!bulkChange && unsetEndpoints.length > 0 ? (
                      <Col>
                        <SelectComponent
                          label="Endpoint"
                          fieldName={"mac_address"}
                          array={unsetEndpoints}
                          onChange={(option) => {
                            handleEndpointChange(option.value);
                          }}
                          selectedOption={selectedDetectedEndpoint}
                        />
                      </Col>
                    ) : (
                      ""
                    )}

                    {!bulkChange &&
                    ports.length > 0 &&
                    subscriberModel == "portAware" ? (
                      <Col>
                        <SelectComponent
                          label="Assigned Port"
                          fieldName={"port"}
                          array={ports}
                          onChange={(option) => {
                            handlePortChange(option);
                          }}
                          stateValue={
                            ports.length === 0 ? (
                              <span style={{ color: "red" }}>
                                No ports available
                              </span>
                            ) : (
                              ""
                            )
                          }
                          selectedOption={selectedPort}
                        />
                      </Col>
                    ) : (
                      ""
                    )}

                    <Col>
                      {bulkChange || (selectedGam && profiles.length > 0) ? (
                        <Col>
                          <SelectComponent
                            label="Profile"
                            fieldName={"profile"}
                            array={profiles}
                            onChange={(option) => {
                              handleProfileChange(option);
                            }}
                            stateValue={states["profile"]}
                            selectedOption={selectedProfile}
                          />
                        </Col>
                      ) : (
                        <Col></Col>
                      )}
                    </Col>
                  </Row>
                </CardBody>
              </Card>

              {showSubscriberDetails() ? (
                <>
                  {bulkChange ? (
                    ""
                  ) : (
                    <Row>
                      <Col>
                        <Card>
                          <CardHeader>
                            <CardTitle tag="h4">Subscriber Details</CardTitle>
                          </CardHeader>
                          <CardBody>
                            <Row>
                              <Col>
                                <label>Name</label>
                                <FormGroup
                                  className={
                                    states["subscriber_name"].length !== 0
                                      ? "has-danger"
                                      : ""
                                  }
                                >
                                  <Input
                                    type="text"
                                    name="subscriber_name"
                                    onChange={(e) =>
                                      Utilities.handleInputChange(
                                        e,
                                        values,
                                        setValues,
                                      )
                                    }
                                    value={values ? values.subscriber_name : ""}
                                  />
                                  <label className="error">
                                    {states["subscriber_name"]}
                                  </label>
                                </FormGroup>
                              </Col>
                              <Col>
                                <label>Description</label>
                                <FormGroup
                                  className={
                                    states["subscriber_description"].length !==
                                    0
                                      ? "has-danger"
                                      : ""
                                  }
                                >
                                  <Input
                                    type="text"
                                    name="subscriber_description"
                                    onChange={(e) =>
                                      Utilities.handleInputChange(
                                        e,
                                        values,
                                        setValues,
                                      )
                                    }
                                    value={
                                      values
                                        ? values.subscriber_description
                                        : ""
                                    }
                                  />
                                  <label className="error">
                                    {states["subscriber_description"]}
                                  </label>
                                </FormGroup>
                              </Col>
                            </Row>
                          </CardBody>
                        </Card>
                      </Col>
                      <Col>
                        {subscriberModel == "portAware" ? (
                          ""
                        ) : (
                          <Card>
                            <CardHeader>
                              <CardTitle tag="h4">Endpoint Details</CardTitle>
                            </CardHeader>
                            <CardBody>
                              <Row>
                                <Col>
                                  <label>MAC Address</label>
                                  <FormGroup
                                    className={
                                      states["mac_address"].length !== 0
                                        ? "has-danger"
                                        : ""
                                    }
                                  >
                                    <Input
                                      type="text"
                                      name="mac_address"
                                      readOnly={
                                        selectedDetectedEndpoint &&
                                        selectedDetectedEndpoint.value != -1
                                          ? true
                                          : false
                                      }
                                      onChange={(e) =>
                                        Utilities.handleInputChange(
                                          e,
                                          values,
                                          setValues,
                                        )
                                      }
                                      value={values ? values.mac_address : ""}
                                    />
                                    <label className="error">
                                      {states["mac_address"]}
                                    </label>
                                  </FormGroup>
                                </Col>

                                <Col>
                                  <label>Name</label>
                                  <FormGroup
                                    className={
                                      states["name"].length !== 0
                                        ? "has-danger"
                                        : ""
                                    }
                                  >
                                    <Input
                                      type="text"
                                      name="name"
                                      onChange={(e) =>
                                        Utilities.handleInputChange(
                                          e,
                                          values,
                                          setValues,
                                        )
                                      }
                                      value={values ? values.name : ""}
                                    />
                                    <label className="error">
                                      {states["name"]}
                                    </label>
                                  </FormGroup>
                                </Col>

                                <Col>
                                  <label>Description</label>
                                  <FormGroup
                                    className={
                                      states["description"].length !== 0
                                        ? "has-danger"
                                        : ""
                                    }
                                  >
                                    <Input
                                      type="text"
                                      name="description"
                                      onChange={(e) =>
                                        Utilities.handleInputChange(
                                          e,
                                          values,
                                          setValues,
                                        )
                                      }
                                      value={values ? values.description : ""}
                                    />
                                    <label className="error">
                                      {states["description"]}
                                    </label>
                                  </FormGroup>
                                </Col>
                              </Row>
                            </CardBody>
                          </Card>
                        )}
                      </Col>
                    </Row>
                  )}
                </>
              ) : (
                ""
              )}

              {showServiceDetails() ? (
                <Row>
                  <Col>
                    <Card>
                      <CardHeader>
                        <CardTitle tag="h4">
                          Service 1 Configuration (Port #1)
                        </CardTitle>
                      </CardHeader>
                      <CardBody>
                        <Row>
                          {!bulkChange ? (
                            <Col>
                              <label className={"settingLabel"}>
                                Trunk Mode
                              </label>
                              <FormGroup>
                                <Switch
                                  name="trunk_mode"
                                  offColor="success"
                                  offText={
                                    <i className="nc-icon nc-simple-remove" />
                                  }
                                  onColor="success"
                                  onText={<i className="nc-icon nc-check-2" />}
                                  onChange={handleTrunkChange}
                                  value={values["trunk_mode"] ? true : false}
                                />
                              </FormGroup>
                            </Col>
                          ) : (
                            <Col>
                              <label className={"settingLabel"}>
                                Trunk Mode
                              </label>
                              <FormGroup>
                                <Checkbox
                                  checked={values["trunk_mode"] === true}
                                  indeterminate={values["trunk_mode"] === null}
                                  onChange={() => {
                                    handleThreeStateChange("trunk_mode");
                                  }}
                                  className="form-check-input"
                                  style={{ width: "20px", height: "20px" }}
                                />
                              </FormGroup>
                            </Col>
                          )}

                          {!bulkChange ? (
                            <Col>
                              <label className={"settingLabel"}>
                                Double Tagging
                              </label>
                              <FormGroup>
                                <Switch
                                  name="double_tagging"
                                  offColor="success"
                                  offText={
                                    <i className="nc-icon nc-simple-remove" />
                                  }
                                  onColor="success"
                                  onText={<i className="nc-icon nc-check-2" />}
                                  onChange={(event) =>
                                    Utilities.handleSwitchChange(
                                      event,
                                      values,
                                      setValues,
                                    )
                                  }
                                  value={
                                    values["double_tagging"] ? true : false
                                  }
                                />
                              </FormGroup>
                            </Col>
                          ) : (
                            <Col>
                              <label className={"settingLabel"}>
                                {" "}
                                Double Tagging
                              </label>
                              <FormGroup>
                                <Checkbox
                                  checked={values["double_tagging"] === true}
                                  indeterminate={
                                    values["double_tagging"] === null
                                  }
                                  onChange={() => {
                                    handleThreeStateChange("double_tagging");
                                  }}
                                  className="form-check-input"
                                  style={{ width: "20px", height: "20px" }}
                                />
                              </FormGroup>
                            </Col>
                          )}

                          {!bulkChange ? (
                            <Col>
                              <label className={"settingLabel"}>
                                Endpoint Tagging
                              </label>
                              <FormGroup>
                                <Switch
                                  name="endpoint_tagging"
                                  offColor="success"
                                  offText={
                                    <i className="nc-icon nc-simple-remove" />
                                  }
                                  onColor="success"
                                  onText={<i className="nc-icon nc-check-2" />}
                                  onChange={(event) =>
                                    Utilities.handleSwitchChange(
                                      event,
                                      values,
                                      setValues,
                                    )
                                  }
                                  value={
                                    values["endpoint_tagging"] ? true : false
                                  }
                                />
                              </FormGroup>
                            </Col>
                          ) : (
                            <Col>
                              <label className={"settingLabel"}>
                                {" "}
                                Endpoint Tagging
                              </label>
                              <FormGroup>
                                <Checkbox
                                  checked={values["endpoint_tagging"] === true}
                                  indeterminate={
                                    values["endpoint_tagging"] === null
                                  }
                                  onChange={() => {
                                    handleThreeStateChange("endpoint_tagging");
                                  }}
                                  className="form-check-input"
                                  style={{ width: "20px", height: "20px" }}
                                />
                              </FormGroup>
                            </Col>
                          )}
                        </Row>
                        <Row>
                          {values["double_tagging"] ? (
                            <>
                              <Col>
                                <SelectComponent
                                  label="S-VLAN Uplink Port"
                                  fieldName={"s_vlan_uplink_port"}
                                  array={uplinkPorts}
                                  stateValue={states["s_vlan_uplink_port"]}
                                  onChange={(option) => {
                                    handleUplinkPortChange(option);
                                  }}
                                  selectedOption={selectedUplinkPort}
                                />
                              </Col>
                              <Col>
                                <label>S-VLAN (Outer Tag)</label>
                                <FormGroup
                                  className={
                                    states["s_vlan_outer_tag"].length !== 0
                                      ? "has-danger"
                                      : ""
                                  }
                                >
                                  <Input
                                    type="number"
                                    name="s_vlan_outer_tag"
                                    placeholder={
                                      bulkChange &&
                                      mixedFields["s_vlan_outer_tag"]
                                        ? "-- mixed --"
                                        : ""
                                    }
                                    onChange={(e) =>
                                      Utilities.handleInputChange(
                                        e,
                                        values,
                                        setValues,
                                      )
                                    }
                                    min={3}
                                    max={4094}
                                    onBlur={(e) => {
                                      if (e.target.value === "") return;
                                      const val = Math.min(
                                        4094,
                                        Math.max(
                                          3,
                                          parseInt(e.target.value, 10) || 3,
                                        ),
                                      );
                                      setValues({
                                        ...values,
                                        s_vlan_outer_tag: val,
                                      });
                                    }}
                                    onKeyDown={(e) => {
                                      if (
                                        ["e", "E", "+", "-", ".", ","].includes(
                                          e.key,
                                        )
                                      ) {
                                        e.preventDefault();
                                      }
                                    }}
                                    value={values ? values.s_vlan_outer_tag : 0}
                                  />
                                  <label className="error">
                                    {states["s_vlan_outer_tag"]}
                                  </label>
                                </FormGroup>
                              </Col>
                            </>
                          ) : (
                            ""
                          )}
                          <Col>
                            <label>
                              {values["double_tagging"]
                                ? "C-VLAN (Inner Tag)"
                                : "VLAN"}
                            </label>
                            <FormGroup
                              className={
                                states["vlan"].length !== 0 ? "has-danger" : ""
                              }
                            >
                              <Input
                                type="number"
                                name="vlan"
                                placeholder={
                                  bulkChange && mixedFields["vlan"]
                                    ? "-- mixed --"
                                    : ""
                                }
                                onChange={(e) =>
                                  Utilities.handleInputChange(
                                    e,
                                    values,
                                    setValues,
                                  )
                                }
                                min={3}
                                max={4094}
                                onBlur={(e) => {
                                  if (e.target.value === "") return;
                                  const val = Math.min(
                                    4094,
                                    Math.max(
                                      3,
                                      parseInt(e.target.value, 10) || 3,
                                    ),
                                  );
                                  setValues({ ...values, vlan: val });
                                }}
                                onKeyDown={(e) => {
                                  if (
                                    ["e", "E", "+", "-", ".", ","].includes(
                                      e.key,
                                    )
                                  )
                                    e.preventDefault();
                                }}
                                value={values ? values.vlan : ""}
                              />
                              <label className="error">{states["vlan"]}</label>
                            </FormGroup>
                          </Col>
                        </Row>
                        <Row>
                          <Col>
                            <label>Remapped VID</label>
                            <FormGroup
                              className={
                                states["remapped_vid"].length !== 0
                                  ? "has-danger"
                                  : ""
                              }
                            >
                              <Input
                                type="number"
                                name="remapped_vid"
                                placeholder={
                                  bulkChange && mixedFields["remapped_vid"]
                                    ? "-- mixed --"
                                    : ""
                                }
                                onChange={(e) =>
                                  Utilities.handleInputChange(
                                    e,
                                    values,
                                    setValues,
                                  )
                                }
                                min={3}
                                max={4094}
                                onBlur={(e) => {
                                  if (e.target.value === "") return;
                                  const val = Math.min(
                                    4094,
                                    Math.max(
                                      3,
                                      parseInt(e.target.value, 10) || 3,
                                    ),
                                  );
                                  setValues({ ...values, remapped_vid: val });
                                }}
                                onKeyDown={(e) => {
                                  if (
                                    ["e", "E", "+", "-", ".", ","].includes(
                                      e.key,
                                    )
                                  ) {
                                    e.preventDefault();
                                  }
                                }}
                                value={values ? values.remapped_vid : 0}
                              />
                              <label className="error">
                                {states["remapped_vid"]}
                              </label>
                            </FormGroup>
                          </Col>
                          <Col>
                            <label>Allowed:Remapped Tagged VLANs</label>
                            <FormGroup
                              className={
                                states["allowed_tagged_vlan"].length !== 0
                                  ? "has-danger"
                                  : ""
                              }
                            >
                              <Input
                                type="text"
                                name="allowed_tagged_vlan"
                                placeholder={
                                  bulkChange &&
                                  mixedFields["allowed_tagged_vlan"]
                                    ? "-- mixed --"
                                    : ""
                                }
                                onChange={(e) =>
                                  Utilities.handleInputChange(
                                    e,
                                    values,
                                    setValues,
                                  )
                                }
                                disabled={values["trunk_mode"]}
                                value={values ? values.allowed_tagged_vlan : ""}
                              />
                              <label className="error">
                                {states["allowed_tagged_vlan"]}
                              </label>
                            </FormGroup>
                          </Col>
                        </Row>
                        <Row>
                          <Col>
                            {showPoe ? (
                              <SelectComponent
                                label="PoE"
                                fieldName={"poe"}
                                array={poeList}
                                stateValue={states["poe"]}
                                onChange={(option) => {
                                  handlePoeChange(option);
                                }}
                                selectedOption={selectedPoe}
                              />
                            ) : (
                              ""
                            )}
                          </Col>
                          <Col>
                            <SelectComponent
                              label="Bandwidth"
                              fieldName={"bandwidth"}
                              array={bandwidths}
                              stateValue={states["bandwidth"]}
                              onChange={(option) => {
                                handleBandwidthChange(option);
                              }}
                              selectedOption={selectedBandwidth}
                            />
                          </Col>
                        </Row>
                      </CardBody>
                    </Card>
                  </Col>
                  <Col>
                    {show2PortsSection ? (
                      <Card>
                        <CardHeader>
                          <CardTitle tag="h4">
                            Service 2 Configuration (Port #2)
                          </CardTitle>
                        </CardHeader>
                        <CardBody>
                          {(deviceFirmware &&
                            deviceFirmware != "1.5.5" &&
                            deviceFirmware != "2.0.0" &&
                            deviceFirmware != "2.0.1") ||
                          bulkChange ? (
                            <Row>
                              {!bulkChange ? (
                                <Col>
                                  <label className={"settingLabel"}>
                                    Endpoint Tagging
                                  </label>
                                  <FormGroup>
                                    <Switch
                                      name="endpoint_tagging_2"
                                      offColor="success"
                                      offText={
                                        <i className="nc-icon nc-simple-remove" />
                                      }
                                      onColor="success"
                                      onText={
                                        <i className="nc-icon nc-check-2" />
                                      }
                                      onChange={(event) =>
                                        Utilities.handleSwitchChange(
                                          event,
                                          values,
                                          setValues,
                                        )
                                      }
                                      value={
                                        values["endpoint_tagging_2"]
                                          ? true
                                          : false
                                      }
                                    />
                                  </FormGroup>
                                </Col>
                              ) : (
                                <Col>
                                  <label className={"settingLabel"}>
                                    {" "}
                                    Endpoint Tagging
                                  </label>
                                  <FormGroup>
                                    <Checkbox
                                      checked={
                                        values["endpoint_tagging_2"] === true
                                      }
                                      indeterminate={
                                        values["endpoint_tagging_2"] === null
                                      }
                                      onChange={() => {
                                        handleThreeStateChange(
                                          "endpoint_tagging_2",
                                        );
                                      }}
                                      className="form-check-input"
                                      style={{ width: "20px", height: "20px" }}
                                    />
                                  </FormGroup>
                                </Col>
                              )}
                            </Row>
                          ) : (
                            ""
                          )}
                          <Row>
                            <Col>
                              <label>VLAN</label>
                              <FormGroup
                                className={
                                  states["vlan2"].length !== 0
                                    ? "has-danger"
                                    : ""
                                }
                              >
                                <Input
                                  type="number"
                                  name="vlan2"
                                  min={3}
                                  max={4094}
                                  placeholder={
                                    bulkChange && mixedFields["vlan2"]
                                      ? "-- mixed --"
                                      : ""
                                  }
                                  onChange={(e) =>
                                    Utilities.handleInputChange(
                                      e,
                                      values,
                                      setValues,
                                    )
                                  }
                                  onBlur={(e) => {
                                    if (e.target.value === "") return;
                                    const val = Math.min(
                                      4094,
                                      Math.max(
                                        3,
                                        parseInt(e.target.value, 10) || 3,
                                      ),
                                    );
                                    setValues({ ...values, vlan2: val });
                                  }}
                                  onKeyDown={(e) => {
                                    if (
                                      ["e", "E", "+", "-", ".", ","].includes(
                                        e.key,
                                      )
                                    )
                                      e.preventDefault();
                                  }}
                                  value={values ? values.vlan2 : ""}
                                />
                                <label className="error">
                                  {states["vlan2"]}
                                </label>
                              </FormGroup>
                            </Col>
                          </Row>
                          {(deviceFirmware &&
                            deviceFirmware != "1.5.5" &&
                            deviceFirmware != "2.0.0" &&
                            deviceFirmware != "2.0.1") ||
                          bulkChange ? (
                            <Row>
                              <Col>
                                <label>Allowed:Remapped Tagged VLANs</label>
                                <FormGroup
                                  className={
                                    states["allowed_tagged_vlan_2"].length !== 0
                                      ? "has-danger"
                                      : ""
                                  }
                                >
                                  <Input
                                    type="text"
                                    name="allowed_tagged_vlan_2"
                                    placeholder={
                                      bulkChange &&
                                      mixedFields["allowed_tagged_vlan_2"]
                                        ? "-- mixed --"
                                        : ""
                                    }
                                    onChange={(e) =>
                                      Utilities.handleInputChange(
                                        e,
                                        values,
                                        setValues,
                                      )
                                    }
                                    disabled={values["trunk_mode"]}
                                    value={
                                      values ? values.allowed_tagged_vlan_2 : ""
                                    }
                                  />
                                  <label className="error">
                                    {states["allowed_tagged_vlan_2"]}
                                  </label>
                                </FormGroup>
                              </Col>
                            </Row>
                          ) : (
                            ""
                          )}
                        </CardBody>
                      </Card>
                    ) : (
                      ""
                    )}
                  </Col>
                </Row>
              ) : (
                ""
              )}

              {showSubmitButton() ? (
                <Row>
                  <Col>
                    <Button className="btn-round" color="info" type="submit">
                      Submit
                    </Button>
                  </Col>
                </Row>
              ) : (
                ""
              )}
            </Form>
          </Col>
        </Row>
      </div>
    </>
  );
};

export default SubscriberEdit;
